$(document).ready(function(){

  //HIDE TERMS&CONDITION FOR EBOOK START
  product_id = $("input[name='product-id']").val();
  // alert(product_id);
  if(parseInt(product_id) == "8252446081189")
  {
      $('.global-checkbox').css('display','none');
      $('#product-checkout-'+product_id).removeAttr('disabled');
  }
  //HIDE TERMS&CONDITION FOR EBOOK END
  
  $('#product_name, #quote_name, #businnes_name, #realestate_name').keyup(function(){
          if($(this).val() == ""){
            $(this).parent().addClass('filled');
            $(this).parent().removeClass('filled-data');
            // $(this).parent().addClass('filled-data');
            $('.error_name').show();
          }else {
            $(this).parent().addClass('filled-data');
            $(this).parent().removeClass('filled');
            // $(this).parent().addClass('filled-data-new');
            $('.error_name').hide();
          }
  });


  $('input.cust_name, input.cust_eamil, input.cust_phone, input.cust_travel, input.cust_travel_dates, textarea.cust_message, input.cust_roommate_name, input.cust_roommate_phone, input.cust_roommate_email').keyup(function(){
      if($(this).val() == ""){
        $(this).parent().addClass('filled');
        $(this).parent().removeClass('filled-data-new');
      }else {
        $(this).parent().addClass('filled-data-new');
        $(this).parent().removeClass('filled');
      }
  });

  $('input.cust_name, input.cust_eamil, input.cust_phone, input.cust_travel, input.cust_travel_dates, textarea.cust_message, input.cust_roommate_name, input.cust_roommate_phone, input.cust_roommate_email').blur(function(){
      if($(this).val() == ""){
        $(this).parent().addClass('filled');
        $(this).parent().removeClass('filled-data-new');
      }else {
        $(this).parent().addClass('filled-data-new');
        $(this).parent().removeClass('filled');
      }
  });

  $('input.cust_name, input.cust_eamil, input.cust_phone, input.cust_travel, input.cust_travel_dates, textarea.cust_message, input.cust_roommate_name, input.cust_roommate_phone, input.cust_roommate_email').click(function(){
      $(this).parent().addClass('filled-data-new');
  });

  /*Email validation*/
  $("input.cust_eamil").change(function () {    
    var inputvalues = $(this).val();    
    var regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;    
    if(!regex.test(inputvalues)){  
      $("#erroremail").html("Please enter valid email id.");
      $("#erroremail").show().delay(3000).fadeOut(); 
      $("#errorrsvpemail").html("Please enter valid email id.");
      $("#errorrsvpemail").show().delay(3000).fadeOut(); 
      return regex.test(inputvalues);    
    }    
  });

  $("input.cust_roommate_email").change(function () {    
    var inputvalues = $(this).val();    
    var regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;    
    if(!regex.test(inputvalues)){  
      $("#errorroommateemail").html("Please enter valid email id.");
      $("#errorroommateemail").show().delay(3000).fadeOut(); 
      return regex.test(inputvalues);    
    }    
  });

  /*Phone validation*/
  $(".cust_phone").keypress(function (e) {
    var keyCode = e.keyCode || e.which;
    $("#errorphone").html("");
    $("#errorrsvpphone").html("");
    var regex = /^[0-9]+$/;
    var isValid = regex.test(String.fromCharCode(keyCode));
    //console.log(isValid);
    if (!isValid) {
      $("#errorphone").html("Only Numbers allowed.");
      $("#errorphone").show().delay(3000).fadeOut();
      $("#errorrsvpphone").html("Only Numbers allowed.");
      $("#errorrsvpphone").show().delay(3000).fadeOut();
    }
    return isValid;
  });

  $(".cust_roommate_phone").keypress(function (e) {
    var keyCode = e.keyCode || e.which;
    $("#errorroommatephone").html("");
    var regex = /^[0-9]+$/;
    var isValid = regex.test(String.fromCharCode(keyCode));
    //console.log(isValid);
    if (!isValid) {
      $("#errorroommatephone").html("Only Numbers allowed.");
      $("#errorroommatephone").show().delay(3000).fadeOut();
    }
    return isValid;
  });


    $('#quote_GroupSize, #quote_StartDate, #quote_EndDate, #quote_Message, #businnes_StartDate, #businnes_EndDate, #businnes_message').keyup(function(){
          if($(this).val() == ""){

            $(this).parent().removeClass('filled-data');
          }else {
            $(this).parent().addClass('filled-data');

          }
  });

     $('#quote_GroupSize, #quote_StartDate, #quote_EndDate, #quote_Message, #businnes_StartDate, #businnes_EndDate, #businnes_message').blur(function(){
          if($(this).val() == ""){
            $(this).parent().addClass('filled-data');
          }else {
            $(this).parent().addClass('filled-data-new');
          }
  });
  
   $('#product_name, #quote_name, #businnes_name, #realestate_name').blur(function(){
          if($(this).val() == ""){
            $(this).parent().addClass('filled filled-data');
            // $('#product_email').parent().addClass('filled filled-data');
            // $('#product_email').parent().addClass('filled filled-data');
            $('.error_name').show();
          }else {
            $(this).parent().addClass('filled-data-new');
            // $('#product_email').parent().addClass('filled-data-new');
            // $('#product_number').parent().addClass('filled-data-new');
            $('.error_name').hide();
          }
  });

  $('#product_email, #quote_email, #businnes_email, #realestate_email').keyup(function(){
          if($(this).val() == ""){
            $(this).parent().addClass('filled');
            $(this).parent().removeClass('filled-data');
            // $(this).parent().addClass('filled-data');
            $('.error_email').show();
            $('.error_invalid').hide();
          }else {
           // $(this).parent().addClass('filled-data-new');
            $('.error_email').hide();
            
                   var regex = /^([a-zA-Z0-9_\.\-\+])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;
	                if(!regex.test($(this).val())) {
                      
	                   $('.error_invalid').show();
                        $(this).parent().addClass('filled');
                        $(this).parent().removeClass('filled-data');
	                    error = 1;
	                }
	                else
	                {
	                   $('.error_invalid').hide();
                       $(this).parent().addClass('filled-data');
                       $(this).parent().removeClass('filled');
	                    error = 0;
	                }
            
            
          }
  });

  $('#product_email, #quote_email, #businnes_email, #realestate_email').blur(function(){
          if($(this).val() == ""){
            $(this).parent().addClass('filled filled-data');
            // $("#product_name").parent().addClass('filled filled-data');
            // $("#product_number").parent().addClass('filled filled-data');
            $('.error_email').show();
          }else {
            $(this).parent().addClass('filled-data-new');
            // $("#product_name").parent().addClass('filled-data-new');
            // $("#product_number").parent().addClass('filled-data-new');
            $('.error_email').hide();
          }
  });
  
  $("#product_number, #quote_number, #businnes_phone, #realestate_number").keypress(function (e) {
         if (e.which != 8 && e.which != 0 && (e.which < 48 || e.which > 57)) {
          $("#errmsg").html("Number Only").stop().show().fadeOut("slow");
          return false;
        }
      });
  
  $('#product_number, #quote_number, #businnes_phone, #realestate_number').keyup(function(){
          if($(this).val() == ""){
            $(this).parent().addClass('filled');
            $(this).parent().removeClass('filled-data');
            // $(this).parent().addClass('filled-data');
            $('.error_number').show();
          }else {
            $(this).parent().addClass('filled-data');
            $(this).parent().removeClass('filled');
            // $(this).parent().addClass('filled-data-new');
            $('.error_number').hide();
          }
  });

  $('#product_number, #quote_number, #businnes_phone, #realestate_number').blur(function(){
          if($(this).val() == ""){
            $(this).parent().addClass('filled filled-data');
            // $("#product_name").parent().addClass('filled filled-data');
            // $("#product_email").parent().addClass('filled filled-data');
            $('.error_number').show();
          }else {
            $(this).parent().addClass('filled-data-new');
            // $("#product_name").parent().addClass('filled-data-new');
            // $("#product_email").parent().addClass('filled-data-new');
            $('.error_number').hide();
          }
  });

  $('#product_name, #quote_name,m #businnes_name, #realestate_name').click(function(){
      $(this).parent().removeClass('filled-data');
    });

  $('#product_email, #quote_email, #businnes_email, #realestate_email').click(function(){
      $(this).parent().removeClass('filled-data');
    });

  $('#product_number, #quote_number, #businnes_phone, #realestate_number').click(function(){
      $(this).parent().removeClass('filled-data');
    });
});

$(document).on('click','.close_btn',function(e){
      e.preventDefault();
      // $(".success_div").hide();
      $(".success_message").html("");
  
});

$(document).on('click','.mfp-close',function(e){
      e.preventDefault();
      $("#product_name").parent().removeClass('filled');
      $("#product_email").parent().removeClass('filled');
      $("#product_number").parent().removeClass('filled');

      $("#quote_name").parent().removeClass('filled');
      $("#quote_email").parent().removeClass('filled');
      $("#quote_number").parent().removeClass('filled');

      $("#businnes_name").parent().removeClass('filled');
      $("#businnes_email").parent().removeClass('filled');
      $("#businnes_phone").parent().removeClass('filled');

      $("#realestate_name").parent().removeClass('filled');
      $("#realestate_email").parent().removeClass('filled');
      $("#realestate_number").parent().removeClass('filled');

      $('.error_name').hide();
      $('.error_email').hide();
      $('.error_number').hide();
      $('#quote_GroupSize, #quote_StartDate, #quote_EndDate, #quote_Message, #businnes_StartDate, #businnes_EndDate, #businnes_message').parent().removeClass('filled-data-new filled-data');
});

$(document).on('click','.product_form',function(e){
   
    var title = $(this).attr('data-product-name'); 
 
    $('#product_send_email').attr('data-product-name',title);

    $('#realestate_send_email').attr('data-product-name',title);
  
    return 0;
  
});

$(document).on('click','#product_send_email',function(e){
    	e.preventDefault();
      
        $("#lbl_message").html(" ");
      	var error_flag = false;
      
      	var name = $("#product_name").val();

        var email = $("#product_email").val();

        var lnumber = $("#product_number").val();

        var message = $("#product_message").val();

		// var title = $('#subject').html();

        var title = $(this).attr('data-product-name');     

        var error = 0;          
      	if(name == '')
        {
           $('.error_name').show();
           $("#product_name").parent().addClass('filled');
            error = 1;       
        }

      	if(email == '')
        {
        	$('.error_email').show();
            $("#product_email").parent().addClass('filled');
            error = 1;
        }
        else
        {
			var regex = /^([a-zA-Z0-9_\.\-\+])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;
            if(!regex.test(email)) {
              $('.error_invalid').show();
              $('#product_email').parent().addClass('filled');
              error = 1;
            }
          	else
            {
                $('.error_invalid').hide();
            	// $('#product_email').css('border-color', '');
            }
        }
      	if(lnumber == '')
        {
            $('.error_number').show();
            $("#product_number").parent().addClass('filled');
            error = 1;
        }

        // ✅ ADD THIS: Check reCAPTCHA
        var captcha = grecaptcha.getResponse();
        if(captcha.length == 0){
            alert("Please verify you are not a robot.");
            return false;
        }

        if(error == 0)
        {
            $('.loadericon').show();
          
            $(this).attr('disabled','disabled');
            // $(this).val('Sending Enquiry...');  
            
            $.ajax({
              type: 'POST', 
              url: 'https://beipcommunity.com/itaglobal/welcome/itaglobal_sendemail_upgrade',
              crossDomain : true,
              dataType: 'json', 
              data: {name:name, email:email, lnumber:lnumber,message:message,title:title},
              success: function(result){
                 $('.loadericon').hide();
                 $("#lbl_message").html(" ");
                 $(".err_close_btn").hide();
                 $(".success_div").show();
                 $("#success_message").html("<p> Thank you for contacting us</p>");  
                 setTimeout(function() { 
                   $(".success_div").hide();
                   $("#success_message").html('');
                 }, 5000);
                 
                 $('#product_form')[0].reset();
    
                 $('#product_send_email').removeAttr('disabled','disabled');
                // $('#product_send_email').val('Enquire Now');

                $("#product_name").parent().removeClass('filled-data-new');
                $("#product_email").parent().removeClass('filled-data-new');
                $("#product_number").parent().removeClass('filled-data-new');
                
              },
              error: function(data){
               
                 $('.loadericon').hide();
              	 $("#lbl_message").html("<p> Something went wrong! </p>");
              
              }
            });
        }
    });


$(document).on('click','#businnes_send_email',function(e){
        e.preventDefault();
        $("#lbl_message").html(" ");
        var error_flag = false;
        var name = $("#businnes_name").val();

        var email = $("#businnes_email").val();

        var lnumber = $("#businnes_phone").val();

        var message = $("#businnes_message").val();
        
        var Destination = $("#businnes_Destination").val();

        var StartDate = $("#businnes_StartDate").val();

        var EndDate = $("#businnes_EndDate").val();

        var title = $(this).siblings("h2").text();

         var error = 0;          
      	if(name == '')
        {
           $('.error_name').show();
           $("#businnes_name").parent().addClass('filled');
            error = 1;       
        }

      	if(email == '')
        {
        	$('.error_email').show();
            $("#businnes_email").parent().addClass('filled');
            error = 1;
        }
        else
        {
			var regex = /^([a-zA-Z0-9_\.\-\+])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;
            if(!regex.test(email)) {
              $('.error_invalid').show();
              $('#businnes_email').parent().addClass('filled');
              error = 1;
            }
          	else
            {
                $('.error_invalid').hide();
            	// $('#product_email').css('border-color', '');
            }
        }
      	if(lnumber == '')
        {
            $('.error_number').show();
            $("#businnes_phone").parent().addClass('filled');
            error = 1;
        }



        // if(error_flag)
        // {
        //   $('.error_div').show();
        //   $(".err_close_btn").show();
        //   return false;
        // }
        // $('.loadericon').show();
        if(error == 0) 
        {
          $.ajax({
          type: 'POST', 
          url: 'https://beipcommunity.com/itaglobal/welcome/itaglobal_sendemail_upgrade',
          crossDomain : true,
          dataType: 'json', 
          data: {name:name, email:email, lnumber:lnumber,message:message,title:title,Destination:Destination,StartDate:StartDate,EndDate:EndDate},
          success: function(result){
            $('.loadericon').hide();
            $("#lbl_message").html(" ");
            $(".err_close_btn").hide();
            $(".success_div").show();
            $("#success_message").html("<p> Thank you for contacting us</p>");  
            setTimeout(function() { 
                   $(".success_div").hide();
                   $("#success_message").html('');
            }, 5000);
            $('#businnes-popup')[0].reset();
            $("#businnes_name").parent().removeClass('filled-data-new');
            $("#businnes_email").parent().removeClass('filled-data-new');
            $("#businnes_phone").parent().removeClass('filled-data-new');
            $('#quote_GroupSize, #quote_StartDate, #quote_EndDate, #quote_Message, #businnes_StartDate, #businnes_EndDate, #businnes_message').parent().removeClass('filled-data-new filled-data');
          },
          error: function(data){

            $('.loadericon').hide();
            $("#lbl_message").html("<p> Something went wrong! </p><button class='close_btn'><i class='fa fa-times' aria-hidden='true'></i></button>");
          }
        });
        }
      });



    $(document).on('click','#quote_send_email',function(e){
        e.preventDefault();
        $("#lbl_message").html(" ");
      	var error_flag = false;
      	var name = $("#quote_name").val();

        var email = $("#quote_email").val();

        var lnumber = $("#quote_number").val();

        var message = $("#quote_Message").val();
      
      	var Destination = $("#quote_Destination").val();

        var GroupSize = $("#quote_GroupSize").val();

        var StartDate = $("#quote_StartDate").val();

        var EndDate = $("#quote_EndDate").val();

		var title = $(this).siblings("h2").text();

   //    	if(name == '')
   //      {
   //      	//alert('Name is required');
   //          $("#lbl_message").append("<p> Name is required </p>");
   //        	var error_flag = true;
   //      }
   //    	else
   //      {
			// $('#quote_name').css('border-color', '');
   //      }
   //    	if(email == '')
   //      {
   //      	//alert('Email is required');
   //          $("#lbl_message").append("<p> Email is required </p>");
   //        	var error_flag = true;
   //      }
   //      else
   //      {
			// var regex = /^([a-zA-Z0-9_\.\-\+])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;
   //          if(!regex.test(email)) {
   //            $("#lbl_message").append("<p> Please enter valid email </p>");
   //            var error_flag = true;
   //          }
   //      }
   //    	if(lnumber == '')
   //      {
   //      	//alert('Phone number is required');
   //          $("#lbl_message").append("<p> Phone number is required </p>");
   //        	var error_flag = true;
   //      }
   //      else
   //      {
			// if (!(/^\d{10}$/.test(lnumber))) {
   //            $("#lbl_message").append("<p> Please enter valid phone number </p>");
   //            var error_flag = true;
   //      	}
   //      }
        /*if(message == '')
        {
        	//alert('Message is required');
            $("#lbl_message").append("<p> Message is required </p>");
          	var error_flag = true;
        }
        if(Destination == '')
        {
        	//alert('Message is required');
            $("#lbl_message").append("<p> Destination is required </p>");
          	var error_flag = true;
        }
        if(GroupSize == '')
        {
        	//alert('Message is required');
            $("#lbl_message").append("<p> GroupSize is required </p>");
          	var error_flag = true;
        }
        if(StartDate == '')
        {
        	//alert('Message is required');
            $("#lbl_message").append("<p> StartDate is required </p>");
          	var error_flag = true;
        }
        if(EndDate == '')
        {
        	//alert('Message is required');
            $("#lbl_message").append("<p> EndDate is required </p>");
          	var error_flag = true;
        }*/
        
      
        // if(error_flag)
        // {
        //   $('.error_div').show();
        //   $(".err_close_btn").show();
        //   return false;
        // }
        // $('.loadericon').show();

        if(name == '')
        {
           $('.error_name').show();
           $("#quote_name").parent().addClass('filled');
            error = 1;       
        }

      	if(email == '')
        {
        	$('.error_email').show();
            $("#quote_email").parent().addClass('filled');
            error = 1;
        }
        else
        {
			var regex = /^([a-zA-Z0-9_\.\-\+])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;
            if(!regex.test(email)) {
              $('.error_invalid').show();
              $('#quote_email').parent().addClass('filled');
              error = 1;
            }
          	else
            {
                $('.error_invalid').hide();
            	// $('#product_email').css('border-color', '');
            }
        }
      	if(lnumber == '')
        {
            $('.error_number').show();
            $("#quote_number").parent().addClass('filled');
            error = 1;
        }
      
        if(error == 0) 
        {      
          $.ajax({
          type: 'POST', 
          url: 'https://beipcommunity.com/itaglobal/welcome/itaglobal_sendemail_upgrade',
          crossDomain : true,
          dataType: 'json', 
          data: {name:name, email:email, lnumber:lnumber,message:message,title:title,Destination:Destination,GroupSize:GroupSize,StartDate:StartDate,EndDate:EndDate},
          success: function(result){
             $('.loadericon').hide();
             $("#lbl_message").html(" ");
             $(".err_close_btn").hide();
             $(".success_div").show();
             $("#success_message").html("<p> Thank you for contacting us</p>");  
                setTimeout(function() { 
                   $(".success_div").hide();
                   $("#success_message").html('');
                 }, 5000);
             $('#quote-popup')[0].reset();
            $("#quote_name").parent().removeClass('filled-data-new');
            $("#quote_email").parent().removeClass('filled-data-new');
            $("#quote_number").parent().removeClass('filled-data-new');
             $('#quote_GroupSize, #quote_StartDate, #quote_EndDate, #quote_Message, #businnes_StartDate, #businnes_EndDate, #businnes_message').parent().removeClass('filled-data-new filled-data');
          },
          error: function(data){
           
            alert('Error occured');
          
          }
        });
        }
    });

$(document).on('click','#realestate_send_email',function(e){
       	e.preventDefault();
        $("#lbl_message").html(" ");
      	var error_flag = false;
      
      	var name = $("#realestate_name").val();

        var email = $("#realestate_email").val();

        var lnumber = $("#realestate_number").val();

        var message = $("#realestate_message").val();
       
      
       	var estatetype = [];
            $.each($("input[name='estateTypes']:checked"), function(){
                estatetype.push($(this).val());
            });

        var agrobiztype = [];
            $.each($("input[name='agrobizType']:checked"), function(){
                agrobiztype.push($(this).val());
            });
       
       	var investmentrange = $("#realestate_investmentrange").val();

		// var title = $(this).siblings("h2").text();
        var title = $(this).attr('data-product-name');

        var error = 0;
       	if(name == '')
        {
           $('.error_name').show();
           $("#realestate_name").parent().addClass('filled');
            error = 1;       
        }

      	if(email == '')
        {
        	$('.error_email').show();
            $("#realestate_email").parent().addClass('filled');
            error = 1;
        }
        else
        {
			var regex = /^([a-zA-Z0-9_\.\-\+])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;
            if(!regex.test(email)) {
              $('.error_invalid').show();
              $('#realestate_email').parent().addClass('filled');
              error = 1;
            }
          	else
            {
                $('.error_invalid').hide();
            	// $('#product_email').css('border-color', '');
            }
        }
      	if(lnumber == '')
        {
            $('.error_number').show();
            $("#realestate_number").parent().addClass('filled');
            error = 1;
        }
   //    	if(estatetype.length == 0)
   //      {
   //         $("#lbl_message").append("<p> Please check one option </p>");
   //         //$('#realestate_number').attr('style', 'border: 2px solid red !important');
   //         var error = 1;
   //      }
          
   //      if(!$('#realestate_investmentrange').val())
   //      {
           
   //         $("#lbl_message").append("<p> Please select one option </p>");
   //         $('#realestate_investmentrange').attr('style', 'border: 2px solid red !important');
   //         var error = 1;
   //      }
   //    	else
   //      {
			// $('#realestate_investmentrange').css('border-color', '');
   //      }
     
        // if(error_flag)
        // {
        //   $('.error_div').show();
        //   $(".err_close_btn").show();
        //   return false;
        // }
        // $('.loadericon').show();

        if(error == 0) 
        {
          $.ajax({
          type: 'POST', 
          url: 'https://beipcommunity.com/itaglobal/welcome/itaglobal_sendemail_upgrade',
          crossDomain : true,
          dataType: 'json', 
          data: {name:name, email:email, lnumber:lnumber,message:message,title:title,estatetype:estatetype,agrobiztype:agrobiztype,investmentrange:investmentrange},
          success: function(result){
             $('.loadericon').hide();
             $("#lbl_message").html(" ");
             $(".err_close_btn").hide();
             $(".error_div").hide();
             $(".success_div").show();
             $("#success_message").html("<p> Thank you for contacting us</p>");  
                setTimeout(function() { 
                   $(".success_div").hide();
                   $("#success_message").html('');
                 }, 5000);
             $('#realestate_form')[0].reset();
            $("#realestate_name").parent().removeClass('filled-data-new');
            $("#realestate_email").parent().removeClass('filled-data-new');
            $("#realestate_number").parent().removeClass('filled-data-new');
          },
          error: function(data){
           
             $('.loadericon').hide();
          	 $("#lbl_message").html("<p> Something went wrong! </p>");
          
          }
        });
        }
    });

//Single Package Email 
$(document).on('click','.emaildata',function(){
  
  var name = $('input[name=name]').val();
  var email = $('input[name=email]').val();
  var phone = $('input[name=phone]').val();
  var travelers = $('input[name=travelers]').val();
  var travel_dates = $('input[name=travel_dates]').val();
  var message = $('textarea#message').val();
  var package_name = $('#package_name_mail').val();
  var hasError = false;
  var regex = /^([\w-\.]+@([\w-]+\.)+[\w-]{2,4})?$/;
  
  if(name == ''){
    $("#errorname").html("Please enter name");
    $("#errorname").show().delay(3000).fadeOut();
  }
  
  if(email == ''){
    $("#erroremail").html("Please enter email id");
    $("#erroremail").show().delay(3000).fadeOut();
    hasError = true;
  }else if(!regex.test(email)){ 
      $("#erroremail").html("Please enter valid email id.");
      $("#erroremail").show().delay(3000).fadeOut(); 
      hasError = true;   
  }
  
  if(phone == ''){
    $("#errorphone").html("Please enter phone number");
    $("#errorphone").show().delay(3000).fadeOut();
  }

  var path = "https://beipcommunity.com/itaglobal";
  
  if(name != '' && email != '' && phone != '' && hasError != true){
  	console.log('In');
    $.ajax({
        url: path + '/Homepage/single_product_mail',
        type:'POST',
      	crossDomain : true,
        dataType    : 'json',
        data      : {'Name': name, 'Email': email, 'Phone': phone, 'Travel': travelers, 'Travel_Dates': travel_dates, 'Message': message, 'PackageName': package_name},
        success:function(result){
         //console.log(result);
         //console.log(result.status);
          if(result.status == 'Success'){
          	$('input[name=name]').val('');
            $('input[name=email]').val('');
            $('input[name=phone]').val('');
            $('input[name=travelers]').val('');
            $('input[name=travel_dates]').val('');
            $('textarea#message').val('');
            $("#successerrormsg").html("Mail send successfully");
    		$("#successerrormsg").show().delay(3000).fadeOut();
          }else{
          	$("#successerrormsg").html("There was an error sending mail");
    		$("#successerrormsg").show().delay(3000).fadeOut();
          }
        }
      });
  
  }else{
  	console.log('Out');
  }
  
});

//RSVP Form
$(document).on('click','.emailrsvpdata',function(){
  
  var rsvpname = $('input[name=rsvpname]').val();
  var rsvpemail = $('input[name=rsvpemail]').val();
  var rsvpphone = $('input[name=rsvpphone]').val();
  var roommatename = $('input[name=roommatename]').val();
  var roommatephone = $('input[name=roommatephone]').val();
  var roommateemail = $('input[name=roommateemail]').val();
  var rsvp_package_name = $('#rsvp_package_name_mail').val();
  var company = $('input[name=company]').val();
  var recaptcha = grecaptcha.getResponse();
  var hasError = false;
  var regex = /^([\w-\.]+@([\w-]+\.)+[\w-]{2,4})?$/;
  
  if(rsvpname == '' || roommatename == ''){
    $("#errorrsvpname").html("Please enter name");
    $("#errorrsvpname").show().delay(3000).fadeOut();
    $("#errorroommatename").html("Please enter name");
    $("#errorroommatename").show().delay(3000).fadeOut();
  }
  
  if(rsvpemail == '' || roommateemail == ''){
    $("#errorrsvpemail").html("Please enter email id");
    $("#errorrsvpemail").show().delay(3000).fadeOut();
    $("#errorroommateemail").html("Please enter email id");
    $("#errorroommateemail").show().delay(3000).fadeOut();
    hasError = true;
  }else if(!regex.test(rsvpemail) || !regex.test(roommateemail)){ 
      $("#errorrsvpemail").html("Please enter valid email id.");
      $("#errorrsvpemail").show().delay(3000).fadeOut();
      $("#errorroommateemail").html("Please enter valid email id.");
      $("#errorroommateemail").show().delay(3000).fadeOut();
      hasError = true;   
  }
  
  if(rsvpphone == '' || roommatephone == ''){
    $("#errorrsvpphone").html("Please enter phone number");
    $("#errorrsvpphone").show().delay(3000).fadeOut();
    $("#errorroommatephone").html("Please enter phone number");
    $("#errorroommatephone").show().delay(3000).fadeOut();
  }

  if (!recaptcha) {
    alert('Please verify captcha');
    return;
  }

  var path = "https://beipcommunity.com/itaglobal";
  
  if(rsvpname != '' && rsvpemail != '' && rsvpphone != '' && hasError != true){
  	console.log('In');
    $.ajax({
        url: path + '/Homepage/rsvp_single_product_mail',
        type:'POST',
      	crossDomain : true,
        dataType    : 'json',
        data      : {'Name': rsvpname, 'Email': rsvpemail, 'Phone': rsvpphone, 'RoommateName': roommatename, 'RoommatePhone': roommatephone, 'RoommateEmail': roommateemail, 'PackageName': rsvp_package_name, 'company': company},
        success:function(result){
         //console.log(result);
         //console.log(result.status);
          if(result.status == 'Success'){
          	$('input[name=rsvpname]').val('');
            $('input[name=rsvpemail]').val('');
            $('input[name=rsvpphone]').val('');
            $('input[name=roommatename]').val('');
            $('input[name=roommatephone]').val('');
            $('input[name=roommateemail]').val('');
            $("#rsvpsuccesserrormsg").html("Mail send successfully");
    		    $("#rsvpsuccesserrormsg").show().delay(6000).fadeOut();
          }else{
          	$("#rsvpsuccesserrormsg").html("There was an error sending mail");
    		    $("#rsvpsuccesserrormsg").show().delay(6000).fadeOut();
          }
        }
      });
  
  }else{
  	console.log('Out');
  }
  
});